import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MeusVeiculosEditPage } from './meus-veiculos-edit.page';

const routes: Routes = [
  {
    path: '',
    component: MeusVeiculosEditPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MeusVeiculosEditPageRoutingModule {}
